import React from 'react';
import KickImage from 'Reuseables/KickImage';
import FooterSection from './Footer';
import BankAccountsSection from './BankAccounts';
import { withRouter } from "react-router-dom"

/* UTILS | HELPERS */
import {
  PAYMENT_LOGOS
} from "../../../../../constants/paymentMethods"
import {
  getCloudImageUrl,
  capitalizeFirstLetter,
  convertToRupiah
} from "../../../../../utils"
import { ASSET_IMAGE } from "../../../../../config"
import {
  renderMessage,
  getHeaderText,
  getStatusIcon,
  getSelectedPayment
} from "../paymentHelpers"

/* COMPONENTS */
import SuccessResult from "../SuccessResult"
import FailedResult from "../FailedResult"
import PendingResult from "../PendingResult"

const BankTransfer = ({ data = [], payment = {}, onClick, expire, orderDetailsData, ...props }) => {
  const {
    invoice_number,
    status,
    expired,
    expiry,
    bank_code,
    payment_method,
    total_amount,
    invoice_url,
    total_adjusted_amount
  } = payment

  const renderLeftSection = () => {
    const payment_logo = PAYMENT_LOGOS[`${payment_method}`]

    if (expired) {
      return <FailedResult
        header_text={getHeaderText(status, expired)}
        orderDetailsData={orderDetailsData}
      >
        {renderMessage(
          status,
          expired,
          null,
          null,
          expiry
        )}
      </FailedResult>
    }

    switch (status) {
      case "COMPLETE":
      case "COMPLETED":
        return <SuccessResult orderDetailsData={orderDetailsData} invoice_number={invoice_number} />
      case "PENDING":
        return (
          <PendingResult
            invoice_number={invoice_number}
            status={status}
            header_text={getHeaderText(status, expired)}
            status_icon={getStatusIcon(status, expired)}
            expiry={expiry}
            bank_code={bank_code}
            payment_logo={getCloudImageUrl(payment_logo)}
            handleExpire={() => null}
            payment_method_text={getSelectedPayment(payment_method, bank_code)}
            amount_to_be_paid={parseInt(total_adjusted_amount)}
            invoice_url={invoice_url}
            onSuccess={() => null}
            onPending={() => null}
            onError={() => null}
            onClose={() => null}
            snapToken={null}
            buttonText={"CONFIRM PAYMENT"}
            customOnClick={() => onClick()}
            isBankTransfer={true}
            banks={data}
            orderDetailsData={orderDetailsData}
          />
        )
      default:
        return (
          <FailedResult
            header_text={getHeaderText(status, expired)}
            orderDetailsData={orderDetailsData}
          >
            {renderMessage(
              status,
              expired,
              null,
              null,
              expiry
            )}
          </FailedResult>
        )
    }
  }

  return (
    <>
      {renderLeftSection()}
      {/* <div>
        <BankAccountsSection data={data} />
        <FooterSection onClick={onClick} expire={expire} />
      </div> */}

      {/* <div id="cicilan-tanpa-kartu-kredit-container">
        <div className="line">
          <p>Thank you, we have received your order</p>
        </div>
        <div className="line">
          <p>ORD ID <u>IKA-O50221_ANX-ZF6</u></p>
        </div>
        <div className="line">
          <p>{getHeaderText(status, expired)}</p>
        </div>
        <div className="line">
          <KickImage src={getStatusIcon(status, expired)} alt="..." />
        </div>
        <div className="line">
          {status === "PENDING" ? <Countdown
            date={moment(expiry).format()}
            renderer={renderer}
            daysInHours={true}
            zeroPadTime={2}
          />
            : <p>00 : 00: 00</p>}
        </div>
        <div className="line">
          <p>Please complete your payment before</p>
        </div>
        <div className="line">
          <p>{moment(expiry).format("dddd, LL HH:mm")}</p>
        </div>
        <div className="line">
          {
            data.map((bank, index) => {
              return <div key={index} className="bank-transfer-card">
                <div className="logo-wrapper">
                  <KickImage src={`${ASSET_IMAGE}/email/${bank.bank_name.toLowerCase()}.png`} />
                </div>
                <div className="payment-wrapper">
                  <p>Payment Method - {bank.bank_name}</p>
                  <p>{bank.account_name}</p>
                  <div className="va-number-wrapper">
                    <p>{bank.account_number}</p>
                    <KickImage src={Copy} alt="..." />
                  </div>
                </div>
              </div>
            })
          }
        </div>
        <div className="line">
          <div className="amount-to-be-paid-wrapper">
            <p>Amount to be paid - </p>
            <p>IDR. {convertToRupiah(amountToBePaid)}</p>
          </div>
        </div>
        <div className="line">
          <p>If you have any questions about your order,
            please contact our team by email to <u>info@kickavenue.com</u>.
            Please put your invoice number into your subject email.</p>
        </div>
        <div className="line">
          <div className="go-to-buying-dashboard-btn"
            onClick={() => props.history.replace("/user_dashboard/order")}
          >
            <p>Go to Buying Dashboard</p>
          </div>
          <div className="continue-payment-wrapper"
            onClick={() => onClick()}
          >
            <p>Complete Payment</p>
          </div>
        </div>
      </div> */}
    </>
  )
}
export default withRouter(BankTransfer);
